import type { FC } from "react";

import { SWReactIcons } from "@similarweb/icons";

import type { ITableCellProps } from "app/components/React/Table/interfaces/ITableCellProps";
import {
    StyledDirectionDeltaValue,
    StyledDirectionDeltaWrapper,
} from "app/pages/sales-intelligence/sub-modules/signals/components/shared/styles";
import { DeltaDirections } from "app/pages/sales-intelligence/sub-modules/signals/types/enums";

import { StyledDirectionIcon } from "./styles";

const IntentScoreDeltaCell: FC<ITableCellProps> = ({ value }) => {
    const getDeltaDirection = () => {
        if (value === 0) {
            return DeltaDirections.INITIAL;
        }

        return value < 0 ? DeltaDirections.DOWN : DeltaDirections.UP;
    };

    const deltaDirection = getDeltaDirection();

    const getArrowIcon = () => {
        if (deltaDirection === DeltaDirections.UP) {
            return (
                <SWReactIcons
                    iconName="arrow-up"
                    size="xs"
                />
            );
        }

        if (deltaDirection === DeltaDirections.DOWN) {
            return (
                <SWReactIcons
                    iconName="arrow-down"
                    size="xs"
                />
            );
        }

        return null;
    };
    return (
        <StyledDirectionDeltaWrapper>
            {deltaDirection === DeltaDirections.INITIAL ? null : (
                <StyledDirectionIcon>{getArrowIcon()}</StyledDirectionIcon>
            )}
            <StyledDirectionDeltaValue direction={deltaDirection}>{Math.abs(value)}</StyledDirectionDeltaValue>
        </StyledDirectionDeltaWrapper>
    );
};
export default IntentScoreDeltaCell;
